module.exports = __webpack_public_path__ + "static/media/portfolio-7.cb1fe8a0.jpg";